import { Plugin, TextSelection } from '@tiptap/pm/state';
import type { EditorState } from '@tiptap/pm/state';

/** Applied to the editor DOM while a non-empty text selection exists (see TaskListEditor.scss). */
export const TASK_LIST_TEXT_SELECTION_CLASS = 'task-list-has-text-selection';

const hasTextSelection = (state: EditorState): boolean =>
    state.selection instanceof TextSelection && !state.selection.empty;

/**
 * Flags the editor DOM with a class while a non-empty text selection exists.
 *
 * The delete button overlays the end of the task text, so during a selection it
 * gets in the way: it swallows the selection drag's hit-testing (collapsing the
 * selection) and its pointerup (deleting the task on release). Styles disable the
 * button's pointer events while this class is present.
 */
export const createTaskListTextSelectionPlugin = (): Plugin =>
    new Plugin({
        props: {
            attributes: (state): Record<string, string> =>
                hasTextSelection(state) ? { class: TASK_LIST_TEXT_SELECTION_CLASS } : {},
        },
    });
